import PropTypes from "prop-types"

const firstName = PropTypes.string
const fullName = PropTypes.string
const loaded = PropTypes.bool.isRequired

const reimbursement = {
  approvalDatetime: PropTypes.string,
  isCardExpense: PropTypes.bool.isRequired,
  submittedDatetime: PropTypes.string,
  paidDatetime: PropTypes.string,
  amount: PropTypes.number,
  status: PropTypes.string.isRequired,
  fileGuid: PropTypes.string,
  cardStatus: function ({ isCardExpense, cardStatus }) {
    if (isCardExpense && !cardStatus) {
      return new Error("Card status expected, but not found for card expense")
    }
  }
}

const reimbursementsList = PropTypes.arrayOf(PropTypes.shape(reimbursement))

export default {
  field: PropTypes.shape({
    value: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired
  }).isRequired,

  reimbursements: PropTypes.shape({
    loaded: PropTypes.bool.isRequired,
    list: reimbursementsList,
    pending: reimbursementsList,
    completed: reimbursementsList
  }).isRequired,

  reimbursement,

  reimbursementsList,

  subsidyStatus: PropTypes.shape({
    loaded: PropTypes.bool.isRequired,
    planStarted: PropTypes.bool,
    yearlyAmounts: PropTypes.shape({
      max: PropTypes.number,
      available: PropTypes.number,
      processing: PropTypes.number,
      used: PropTypes.number
    }),
    reimbursementPercent: PropTypes.number
  }).isRequired,

  userInfo: {
    all: PropTypes.shape({
      loaded,
      firstName,
      fullName,
      lastName: PropTypes.string,
      title: PropTypes.string
    }).isRequired,
    loaded,
    firstName,
    fullName
  }
}
